export default __webpack_public_path__ + "static/mockupsProPagePlanner2-ddffdd13993434a5950a696c79ebc869.jpg";